<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <el-table class="mt10" ref="multipleTable" :data="orderGoodsAllocFormList" :row-key="getRowKeys" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
            <el-table-column :key="Math.random()" width="55" v-if="!multiSelect">
                <template slot-scope="rows">
                    <el-radio v-model="orderGoodsAllocForm.id" :label="rows.row.id">&nbsp;</el-radio>
                </template>
            </el-table-column>
            <el-table-column :key="Math.random()" width="55" :selectable="selectable" align="center" type="selection" v-if="multiSelect"></el-table-column>
            <el-table-column :key="Math.random()" prop="title" label="配货单名称" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column :key="Math.random()" prop="orderNo" label="订单编号" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column :key="Math.random()" prop="buyerName" label="买家名称" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column :key="Math.random()" prop="buyerShopName" label="买家业务单元" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column :key="Math.random()" prop="buyerBizUnitName" label="买家所属部门" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column :key="Math.random()" prop="buyerRecvAddr" label="地址信息" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column :key="Math.random()" prop="createTime" label="创建时间" align="left" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import goodsOrderApi from '../../api/goodsOrder'
    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "配货单名称",
            "code": "title",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "订单编号",
            "code": "orderNo",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "买家名称",
            "code": "buyerName",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "买家机构",
            "code": "buyerShopName",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "地址信息",
            "code": "buyerRecvAddr",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "创建时间",
            "code": "createTime",
            "basic": true
        }]
    };
    export default {
        name: 'swb-alloc-form-for-select',
        desc: '配货单-选择',
        props: {
            sellerId: {
                type: Number,
            },
            sellerType: {
                type: Number,
            },
            //是否多选
            multiSelect: {
                type: Boolean,
                default: true
            },
            multiSelectDisabled: {
                type: Boolean,
                default: false
            },
            //单选初始选择项
            checkedItem: {
                type: Object,
                default: null
            },
            initCheckedIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            checkedIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            state: {
                type: Number,
                default: 1,
            },
            orderFlag: {
                type: Boolean,
                default: false
            },
            orderId: {
                type: Number,
                default: null,
            }
        },
        data: function () {
            return {
                //
                //分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryConfig: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //
                orderGoodsAllocFormList: [],
                orderGoodsAllocForm: {},
                checkedList: [],
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'multipleTable',
                checkedIdsX: [],
                //
                getRowKeys(row) {
                    return row.id;
                },
            }
        },
        created: function () {
            let self = this;
            self.pageSize = self.pageSizes.first();
            self.queryConfig = searchConfigData;
            self.checkedIdsX = self.checkedIds.clone();
            this.checkedIdsX.forEach(function (id) {
                let msu = {};
                msu.ssuId = id;
                self.checkedList.add(msu);
            });
            self.getOrderGoodsAllocFormList();
        },
        methods: {
            selectable: function (row, index) {
                if(this.multiSelectDisabled) {
                    let initCheckedIds = this.initCheckedIds;
                    if(initCheckedIds.indexOf(row.id) >= 0) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            },
            addCheckId: function (id, val) {
                let self = this;
                if(!self.checkedIdsX.contains(id)) {
                    self.checkedIdsX.add(id);
                    self.checkedList.add(val);
                    return id;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if(self.checkedIdsX.contains(id)) {
                    for(let i = 0; i < self.checkedList.length; i++) {
                        let orderGoodsAllocForm = self.checkedList[i];
                        if(orderGoodsAllocForm.id == id) {
                            self.checkedList.splice(i, 1);
                        }
                    }
                    self.checkedIdsX.remove(id);
                    return id;
                }
                return null;
            },
            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                //
                let allIds = self.orderGoodsAllocFormList.pluck("id");
                let selIds = selRows.pluck("id");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index]);
                });
                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },
            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            //===========回显禁用结束===============
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.ceil(curStartIndex / this.pageSize);
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = val;
                this.getOrderGoodsAllocFormList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.getOrderGoodsAllocFormList();
            },
            getOrderGoodsAllocFormList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.sellerId = self.sellerId;
                filterItems.sellerType = self.sellerType;
                filterItems.orderFlag = self.orderFlag;
                filterItems.orderId = self.orderId;
                filterItems.state = self.state;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                goodsOrderApi.getOrderGoodsAllocFormList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let resultData = result.data;
                        self.orderGoodsAllocFormList = resultData.rows;
                        let pagination = resultData.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;

                        setTimeout(function () {
                            self.restoreSelRows(self.orderGoodsAllocFormList, self.checkedTblRefId, 'ssuId');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 单选
            handleCurrentChange: function (val) {
                if(this.multiSelect == null || this.multiSelect == false) {
                    this.orderGoodsAllocForm = Utils.merge({}, val);
                    //
                }
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                if((Utils.isNoB(self.orderGoodsAllocForm) || Utils.isNoB(self.orderGoodsAllocForm.id)) && self.checkedList.length <= 0) {
                    result.type = 'warn';
                    result.message = '至少选择一个配货单！';
                    return result;
                }
                if(Utils.isFalse(self.multiSelect)) {
                    result.type = 'info';
                    result.data = self.orderGoodsAllocForm;
                } else {
                    result.type = 'info';
                    result.data = self.checkedList;
                }
                return result;
            }
        }
    }

</script>





// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocFormForSelect.vue